export class TimeListParameters {
  public increment: number | null = null;

  public minHour: number | null = null;
  public minMinutes: number | null = null;
  
  public maxHour: number | null = null;
  public maxMinutes: number | null = null;
}
